import React from 'react';
import { Box, Stack, Typography } from '@mui/material';

import { pickWaitingLines, rememberShownLines } from './waitingMessages';

const TICK_MS = 1_000;

const DOT_COUNT = 3;

let lastShownLines: string[] = [];

const PinguWaitingIndicator = () => {
  const [elapsedMs, setElapsedMs] = React.useState(0);
  const [messages] = React.useState(() => pickWaitingLines(Math.random, lastShownLines));

  React.useEffect(() => {
    lastShownLines = rememberShownLines(lastShownLines, messages, elapsedMs);
  }, [messages, elapsedMs]);

  React.useEffect(() => {
    const startedAt = Date.now();
    const timer = setInterval(() => setElapsedMs(Date.now() - startedAt), TICK_MS);

    return () => clearInterval(timer);
  }, []);

  const message = messages.reduce(
    (current, { afterMs, text }) => (afterMs <= elapsedMs ? text : current),
    messages[0].text,
  );

  return (
    <Stack
      direction="row"
      spacing={1}
      alignItems="center"
      role="status"
      aria-live="polite"
      sx={{ py: 1 }}
    >
      <Box
        aria-hidden
        sx={{
          display: 'flex',
          gap: 0.5,
          '@keyframes pinguWaitingDot': {
            '0%, 80%, 100%': { opacity: 0.25 },
            '40%': { opacity: 1 },
          },
        }}
      >
        {Array.from({ length: DOT_COUNT }, (_, index) => index).map((dot) => (
          <Box
            key={dot}
            sx={{
              width: 5,
              height: 5,
              borderRadius: '50%',
              backgroundColor: 'text.secondary',
              animation: `pinguWaitingDot 1.4s ease-in-out ${dot * 0.16}s infinite`,
              '@media (prefers-reduced-motion: reduce)': {
                animation: 'none',
                opacity: 0.55,
              },
            }}
          />
        ))}
      </Box>
      <Typography variant="reading" color="text.secondary">
        {message}
      </Typography>
    </Stack>
  );
};

export default PinguWaitingIndicator;
